import { tagsBubble, resetFilteredNetwork } from "./helper";
import { netwerkInitMap } from "./mapHelper";

// document.addEventListener("DOMContentLoaded", netwerkInitMap);
document.addEventListener("DOMContentLoaded", function () {
  var netwerkMapCanvas = document.getElementById("netwerk-map-canvas");

  if (netwerkMapCanvas) {
    netwerkInitMap();
  }
});

// ------------------------- HOME MAP ---------------------------------

document.addEventListener('DOMContentLoaded', function () {
  //REMOVE ALL FILTERS ON PAGE LOAD
  const tags = sessionStorage.getItem("networktags");
  const themas = sessionStorage.getItem("thematags");
  const jsonTags = tags ? JSON.parse(tags) : { tags: [] };
  const jsonThemas = themas ? JSON.parse(themas) : { thema: [] };

  const checkboxes = document.querySelectorAll(".thematag");
  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  const gratisCheckbox = document.getElementById("thema-gratis");
  if (gratisCheckbox) gratisCheckbox.checked = false;

  jsonTags.tags = [];
  jsonThemas.thema = [];
  sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
  sessionStorage.setItem("thematags", JSON.stringify(jsonThemas));
  sessionStorage.setItem("networksearchtags", "");
  console.log("gratis adding....2");
  sessionStorage.setItem("themagratistags", "");
  tagsBubble();
  netwerkInitMap();
  resetFilteredNetwork();
});

// function homeInitMap() {

//   var homeMapElement = document.getElementById("home-map-canvas");
//   if (homeMapElement) {
//     netwerkInitMap();

//   }

// }

// document.addEventListener("DOMContentLoaded", homeInitMap);
document.addEventListener("DOMContentLoaded", function () {
  var homeMapCanvas = document.getElementById("home-map-canvas");

  if (homeMapCanvas) {
    netwerkInitMap();
    tagsBubble();
  }
});

/**
 * Add clicks to network list
 * the available tags
 */
function expertiseFilter() {
  const networkTags = document.querySelectorAll(".networktag");

  // console.log("yes expertise work");

  networkTags.forEach(function (networkTag) {
    networkTag.addEventListener("click", function () {
      const expertise = networkTag.getAttribute("data-expertise");
      parseSessionStorage(expertise);
      console.log("xxx expert", expertise);

      const buttonElement = document.getElementById("dropdownMenuMap");
      buttonElement.textContent = expertise;
    });

    // Add keydown event listener to handle Enter key
    networkTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const expertise = networkTag.getAttribute("data-expertise");
        parseSessionStorage(expertise);
        console.log("xxx expert", expertise);

        const buttonElement = document.getElementById("dropdownMenuMap");
        buttonElement.textContent = expertise;
      }
    });
  });
}

function themaFilter() {
  const themaTags = document.querySelectorAll(".thematag");

  themaTags.forEach(function (themaTag) {
    let clicked = false;

    themaTag.addEventListener("click", function () {
      const checkmark = this.nextElementSibling;

      const thema = themaTag.getAttribute("data-thema");

      if (clicked) {
        checkmark.style.backgroundColor = "";
        clicked = false; // Reset clicked state
      } else {
        const bgColor = themaTag.getAttribute("data-color");
        checkmark.style.backgroundColor = bgColor;
        clicked = true; // Set clicked state
      }
      parseSessionStorageThema(thema);
    });

    // Add keydown event listener to handle Enter key
    themaTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const checkmark = this.nextElementSibling;
        const thema = themaTag.getAttribute("data-thema");

        if (clicked) {
          checkmark.style.backgroundColor = "";
          clicked = false; // Reset clicked state
          themaTag.checked = false;
        } else {
          const bgColor = themaTag.getAttribute("data-color");
          checkmark.style.backgroundColor = bgColor;
          clicked = true; // Set clicked state
          themaTag.checked = true;
        }
        parseSessionStorageThema(thema);
      }
    });
  });
}

/**
 * add the tags to session storage
 * @param {*} expertise
 */
function parseSessionStorage(expertise) {
  const tags = sessionStorage.getItem("networktags");
  if (tags) {
    // hasFilter = true;
    const jsonTags = JSON.parse(tags);
    if (jsonTags.tags.indexOf(expertise) === -1) {
      jsonTags.tags = [];
      jsonTags.tags.push(expertise);
    }

    // console.log({jsonTags});
    sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
    tagsBubble();
  }
}

/**
 * add the tags to session storage
 * @param {*} thema
 */
function parseSessionStorageThema(thema) {
  const tags = sessionStorage.getItem("thematags");

  if (tags) {
    const jsonTags = JSON.parse(tags);
    const index = jsonTags.thema.indexOf(thema);

    if (index === -1) {
      jsonTags.thema.push(thema);
    } else {
      jsonTags.thema.splice(index, 1);
    }

    sessionStorage.setItem("thematags", JSON.stringify(jsonTags));
    tagsBubble();
  }
}

/**
 * handles the input of network list search
 */
function networkListSearch() {
  const eventSearchInputs = document.querySelectorAll(".searchQueryNetwork");
  const searchButton = document.getElementById("searchQuerySubmit");

  function applySearch(input) {
    const inputValue = input.value.trim();

    if (!inputValue) return;

    sessionStorage.setItem("networksearchtags", inputValue);
    tagsBubble();
  }

  eventSearchInputs.forEach(function (eventSearchInput) {
    eventSearchInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        applySearch(eventSearchInput);
      }
    });
  });

  if (searchButton) {
    searchButton.addEventListener("click", function (event) {
      event.preventDefault();
      const input = document.getElementById("searchQueryInput");

      if (input) {
        applySearch(input);
      }
    });
  }
}

networkListSearch();
expertiseFilter();
themaFilter();
